import type { LucideIcon } from "lucide-react";
import type { FC } from "react";
import type { PinCandidateRow as PinCandidateRowData } from "web_myplann/Portfolio/Components/Redesign/Detail/Pin/usePinCandidateRows";
import { ListRow } from "web_myplann/Shared/Components/ListRow";

type Props = {
	row: PinCandidateRowData;
	Icon: LucideIcon;
	iconSize: number;
	iconColor: string;
	iconBg: string;
	isLast: boolean;
	disabled: boolean;
	onClick: () => void;
};

export const PinCandidateRow: FC<Props> = ({
	row,
	Icon,
	iconSize,
	iconColor,
	iconBg,
	isLast,
	disabled,
	onClick,
}) => (
	<ListRow
		onClick={onClick}
		disabled={disabled}
		icon={<Icon size={iconSize} color={iconColor} />}
		iconBg={iconBg}
		title={row.title}
		subtitle={row.subtitle}
		isLast={isLast}
	/>
);
